<template>
  <div @click="$emit('click')" class="p-2 position-relative bet-slip-options d-flex align-items-center mb-2">
    <i
      class="far fa-question-circle mr-1"
      style="cursor: pointer;"
      @click.stop="$emit('markClick')"
      v-if="showQuestionMark"
    ></i>
    <div class="inner-font">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'showQuestionMark'],
};
</script>

<style lang="scss">
.bet-slip-options {
  cursor: pointer;
  background-color: #f4f4f4;
  font-weight: 500;
  border-bottom: 1px solid #e8e8e8;
  height: 30px;
  font-size: 14px;

  .kiosk & {
    border-radius: 4px;
  }
}
</style>
